import { useEffect, useState } from "react";
import swal from "sweetalert2";
import * as helper from '../global/helper';
import { getRangeFeeCalendarAll, getRangeFeeMasterByCalenderID, postRangeFeeMaster } from "../api/matAPI";
import AddRangeFeeCalendar from "./addRangeFeeCalendar";
import { today as todayFromServer } from "../../assets/scripts/periodSelection";
import RightSideDetails from "../global/rightSideDetails";

const RangeFeeCalendar = (props) => {

    const [currentCalendarID,                     setCurrentCalendarID]                          = useState(null);
    const rows = [
    { no: 1,  CategoryID: 1, SubCategoryID: 1, Type: 'Mat',  UserType: 'Member', WeekType: 'Weekday' },
    { no: 2,  CategoryID: 1, SubCategoryID: 1, Type: 'Mat', UserType: 'Member', WeekType: 'Weekends' },
    { no: 3,  CategoryID: 1, SubCategoryID: 1, Type: 'Grass', UserType: 'Member', WeekType: 'Weekday' },
    { no: 4,  CategoryID: 1, SubCategoryID: 1, Type: 'Grass', UserType: 'Member', WeekType: 'Weekends' },
    { no: 5,  CategoryID: 1, SubCategoryID: 2, Type: 'Mat', UserType: 'Residential Member', WeekType: 'Weekday' },
    { no: 6,  CategoryID: 1, SubCategoryID: 2, Type: 'Mat', UserType: 'Residential Member', WeekType: 'Weekends' },
    { no: 7,  CategoryID: 1, SubCategoryID: 2, Type: 'Grass', UserType: 'Residential Member', WeekType: 'Weekday' },
    { no: 8,  CategoryID: 1, SubCategoryID: 2, Type: 'Grass', UserType: 'Residential Member', WeekType: 'Weekends' },
    { no: 9,  CategoryID: 1, SubCategoryID: 3, Type: 'Mat', UserType: 'Junior Member', WeekType: 'Weekday' },
    { no: 10, CategoryID: 1, SubCategoryID: 3, Type: 'Mat', UserType: 'Junior Member', WeekType: 'Weekends' },
    { no: 11, CategoryID: 1, SubCategoryID: 3, Type: 'Grass', UserType: 'Junior Member', WeekType: 'Weekday' },
    { no: 12, CategoryID: 1, SubCategoryID: 3, Type: 'Grass', UserType: 'Junior Member', WeekType: 'Weekends' },
    { no: 13, CategoryID: 2, SubCategoryID: 4, Type: 'Mat', UserType: 'Walk-in Guest', WeekType: 'Weekday' },
    { no: 14, CategoryID: 2, SubCategoryID: 4, Type: 'Mat', UserType: 'Walk-in Guest', WeekType: 'Weekends' },
    { no: 15, CategoryID: 2, SubCategoryID: 4, Type: 'Grass', UserType: 'Walk-in Guest', WeekType: 'Weekday' },
    { no: 16, CategoryID: 2, SubCategoryID: 4, Type: 'Grass', UserType: 'Walk-in Guest', WeekType: 'Weekends' },
    { no: 17, CategoryID: 2, SubCategoryID: 5, Type: 'Mat', UserType: 'Members Guest', WeekType: 'Weekday' },
    { no: 18, CategoryID: 2, SubCategoryID: 5, Type: 'Mat', UserType: 'Members Guest', WeekType: 'Weekends' },
    { no: 19, CategoryID: 2, SubCategoryID: 5, Type: 'Grass', UserType: 'Members Guest', WeekType: 'Weekday' },
    { no: 20, CategoryID: 2, SubCategoryID: 5, Type: 'Grass', UserType: 'Members Guest', WeekType: 'Weekends' },
    { no: 21, CategoryID: 2, SubCategoryID: 6, Type: 'Mat', UserType: 'Defence Guest', WeekType: 'Weekday' },
    { no: 22, CategoryID: 2, SubCategoryID: 6, Type: 'Mat', UserType: 'Defence Guest', WeekType: 'Weekends' },
    { no: 23, CategoryID: 2, SubCategoryID: 6, Type: 'Grass', UserType: 'Defence Guest', WeekType: 'Weekday' },
    { no: 24, CategoryID: 2, SubCategoryID: 6, Type: 'Grass', UserType: 'Defence Guest', WeekType: 'Weekends' }
];

    const MEMBERSHIP_LABELS = {
        1: 'Golf Membership',
        2: 'Social Membership',
        3: 'Range Membership'
    };


    const getInitialRateMaster = (calendarID = null) => {
        return rows.map(row => ({
            ID: row.ID,
            CalenderID: calendarID,
            CategoryID: row.CategoryID,
            SubCategoryID: row.SubCategoryID,
            UserType: row.UserType,
            IsWeekend: row.WeekType == "Weekday" ? "N" : "Y",
            Type: row.Type,
            GreenFee: 0,
            Bucket50: 0,
            Bucket100: 0,
            Bucket150: 0,
            Bucket200: 0,
            Club: 0,
            Tax: 0,
            Total: 0,
            Remark: ''
        }));
    };

    const [showModal,                             setShowModal]                                  = useState(false);
    const [isInit,                                setIsInit]                                     = useState(true);
    const [allMaster,                             setAllMaster]                                  = useState([]);
    const [rangeFeeMaster,                        setRangeFeeMaster]                             = useState([]);
    const [rightSideDetails,                      setRightSideDetails]                           = useState(false);
    const [editingCalendar,                       setEditingCalendar]                            = useState(null);
    const [isRateEditable,                        setIsRateEditable]                             = useState(true);
    
    useEffect(() => {
        props.title("Range Fee Calendar", "range-fee-calendar");
        fetchRangeFeeCalendar();
    }, []);

    useEffect(() => {
        if (rightSideDetails) {
            Config.Core.OpenDrawer();
        } else {
            setRangeFeeMaster(getInitialRateMaster());
            setCurrentCalendarID(null);
        }
    }, [rightSideDetails]);

    useEffect(() => {
        if (!isInit) {
            fillDataTable();
        }
    }, [allMaster]);

    const handleDismissModal = () => {
        setShowModal(false);
        setEditingCalendar(null);
    };

    const handleMasterClick = (e) => {
        // console.log('handleMasterClick() --->');
        e.preventDefault();
        setShowModal(true);
        setEditingCalendar(null);
    };

    const handleEditClick = (calendarData) => {
        setEditingCalendar(calendarData);       
        setShowModal(true);
    };

    const refetchCalendars = () => {
        fetchRangeFeeCalendar();
    };

    const updateRangeFeeMasterRate = (userType, type, isWeekend, field, value) => {
        setRangeFeeMaster((prevDetails) => {
            return prevDetails.map(detail => {
                if (detail?.UserType === userType && detail?.Type === type && detail?.IsWeekend === isWeekend) {
                    const updatedDetail = { ...detail, [field]: value };

                    const greenFee = parseFloat(updatedDetail.GreenFee) || 0;
                    const bucket50 = parseFloat(updatedDetail.Bucket50)   || 0;
                    const bucket100 = parseFloat(updatedDetail.Bucket100) || 0;
                    const bucket150 = parseFloat(updatedDetail.Bucket150) || 0;
                    const bucket200 = parseFloat(updatedDetail.Bucket200) || 0;
                    const club      = parseFloat(updatedDetail.Club) || 0;

                    const rate = greenFee + bucket50 + bucket100 + bucket150 + bucket200 + club;
                    const tax = rate * 0.18;
                    const total = rate + tax;

                    updatedDetail.Tax   = Math.round(tax);
                    updatedDetail.Total = Math.round(total);

                    return updatedDetail;
                }
                return detail;
            });
        });
    };

    function showEditButton(row) {
        const formattedCurrentDate = moment(todayFromServer);
        var optString = '';

        const isEdit = formattedCurrentDate.isBetween(row.StartDate, row.EndDate);

        optString += '<center>'
        optString += `<button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-invoice " ><i class="fa fa-file-alt"></i></button>`

        if (!isEdit) optString += `<button type="button"  class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-edit ml-4"><i class="flaticon2-edit"></i></button>`
        
        optString += '</center>'

        return optString;
    }

    const closeDrawer = () => {
        Config.Core.CloseDrawer();
        setTimeout(() => {
            setRightSideDetails(false);
            setIsRateEditable(true);
        }, 200);
    };

    const fetchRangeFeeCalendar = async() => {
        try {
            const response = await getRangeFeeCalendarAll();
            // console.log('response :- ', response);
            isInit ? setIsInit(false) : $('#tblMaster').KTDatatable().destroy();
            setAllMaster(response?.allRangeFeeCalendar);
        } catch (error) {
            swal.fire({ icon: 'error', titleText: error.message });
        }
    };

    const fetchRangeFeeMasterByCalendarID = async (calendarID) => {
        try {
            setCurrentCalendarID(calendarID);
            const result = await getRangeFeeMasterByCalenderID(calendarID);
            if (result?.rangeFeeMaster?.length > 0) {
                const normalizedResult = result?.rangeFeeMaster?.map(row => ({
                    ...row,
                    Bucket50:  row['50Balls'],
                    Bucket100: row['100Balls'],
                    Bucket150: row['150Balls'],
                    Bucket200: row['200Balls']
                }));
                setRangeFeeMaster(normalizedResult);
            } else {
                setRangeFeeMaster(getInitialRateMaster(calendarID));
            }

        } catch (error) {
            swal.fire({ icon :'error', titleText : error.message });
        }
    };

    const handleSave = async () => {
        const btn = $('#btnSave');
        helper.StartProcessing(btn);
        try {
            await postRangeFeeMaster(rangeFeeMaster);
            if (rangeFeeMaster[0]?.ID) {
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Master updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3500,
                    onOpen: () => swal.hideLoading()
                });
            } else {
                swal.fire({
                    icon: 'success',
                    titleText: 'Master added successfully!',
                    showConfirmButton: false,
                    timer: 3500,
                    onOpen: () => swal.hideLoading()
                });
            }
            fetchRangeFeeMasterByCalendarID(currentCalendarID);
            helper.StopProcessing(btn);
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon: 'error',
                titleText: 'Error!',
                text: err.message,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand',
            });
            return;
        }
        // return;
    };

    function fillDataTable() {
        const dataTable = $('#tblMaster').KTDatatable({
            data: {
                saveState: false,
                source   : allMaster,
                pageSize : 20
            },
            layout: {
                scroll: true,
                height: $(window).height() - 250,
                footer: false,
            },
            sortable   : true,
            pagination : true,
            search     : { input: $('#generalSearch') },
            columns    : [
                {  field: 'Name',  title: 'Name', width:250 },
                {
                    field: 'StartDate',
                    title: 'Start Date',
                    width: 120,
                    template: (row) => moment(row.StartDate).format('DD-MMM-YYYY'),  
                },
                {
                    field: 'EndDate',
                    title: 'End Date',
                    width:120,
                    template: (row) => moment(row.EndDate).format('DD-MMM-YYYY'),
                },
                {
                    field: '',
                    title: 'Action',
                    width: 90,
                    template: function(row) {
                        return showEditButton(row);
                    }
                }
            ]
        });

        // for edit button click for range calendar
        dataTable.on('click', '.btn-edit', function (e) {
            e.stopPropagation();
            e.preventDefault();
            e.stopImmediatePropagation();
            const $row = $(this).closest('tr');
            const index = $row.index();
            const rowData = dataTable.dataSet[index];
            // console.log('rowData :- ', rowData);
            if (rowData) {
                handleEditClick(rowData);
            }
        });

        dataTable.on('click', '.btn-invoice', function (e) {
            e.stopPropagation();
            const $row = $(this).closest('tr');
            const index = $row.index();
            const rowData = dataTable.dataSet[index];
            if (rowData) {
                const today = moment(todayFromServer)
                const isBetween = today.isSameOrAfter(moment(rowData.StartDate)) && today.isSameOrBefore(moment(rowData.EndDate)); // checking if calendar is active or not
                setIsRateEditable(!isBetween);
                setRightSideDetails(true);
                fetchRangeFeeMasterByCalendarID(rowData?.ID);
            }
        });
    }

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet kt-portlet--mobile">
                        <div className="kt-portlet__head kt-portlet__head--lg padding-l0">
                            <div className="kt-portlet__head-label">
                                <div className="row align-items-center margin-l10">
                                    <div className="col-md-12 kt-margin-b-20-tablet-and-mobile margin-b0">
                                        <div className="kt-input-icon kt-input-icon--left">
                                            <input type="text" className="form-control clientSearch" placeholder="Search Master..." id="generalSearch" />
                                            <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="kt-portlet__head-toolbar">
                                <div className="kt-portlet__head-wrapper">
                                    <div className="kt-portlet__head-actions">
                                        <button onClick={handleMasterClick} type="button" className="btn btn-brand btn-icon-sm text-white d-inline"><i className="la la-plus"></i> New Master </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="kt-portlet__body kt-portlet__body--fit">
                            <div id="tblMaster" className="kt-datatable table-striped clickable"></div>
                            {rightSideDetails && <>
                                <RightSideDetails title="Range Fee Master" onCloseDrawer={() => closeDrawer()}>
                                    <div className="kt-portlet">
                                        <div className="kt-portlet__body padding-t30 padding-b0">
                                            <form className="kt-form" id="addMasterForm">
                                                <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                                    {/* table will be here */}
                                                    <div id="accordionExample4">
                                                        <div className="kt-widget4">
                                                            <div className="kt-widget4__item padding-tb5">
                                                                <table id="tblGreenFee" className="table table-bordered" style={{ width: '100%', backgroundColor: 'none' }}>
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{ width: '4%' }}>No</th>
                                                                            <th style={{ width: '14%' }}>Particular</th>
                                                                            <th style={{ width: '6%' }}>Type</th>
                                                                            <th style={{ width: '8%' }}>Days</th>
                                                                            <th style={{ width: '9%' }}>Green Fee</th>
                                                                            <th style={{ width: '8%' }}>50 Balls</th>
                                                                            <th style={{ width: '8%' }}>100 Balls</th>
                                                                            <th style={{ width: '8%' }}>150 Balls</th>
                                                                            <th style={{ width: '8%' }}>200 Balls</th>
                                                                            <th style={{ width: '8%' }}>Club</th>
                                                                            <th style={{ width: '9%' }}>Tax</th>
                                                                            <th style={{ width: '9%' }}>Total</th>
                                                                            <th style={{ width: '18%' }}>Remarks</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {rangeFeeMaster.length > 0 && rangeFeeMaster.map((detail, index) => (
                                                                            <tr key={index}>
                                                                                <td>{index + 1}</td>
                                                                                <td>{detail?.UserType}</td>
                                                                                <td>{detail?.Type}</td>
                                                                                <td>{detail?.IsWeekend === 'Y' ? 'Weekend' : 'Weekday'}</td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control input-sm"
                                                                                        value={detail?.GreenFee || 0}
                                                                                        disabled={!isRateEditable}
                                                                                        onChange={(e) => updateRangeFeeMasterRate(detail.UserType, detail.Type, detail.IsWeekend, 'GreenFee', e.target.value)} 
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control input-sm"
                                                                                        value={detail?.Bucket50 || 0}
                                                                                        disabled={!isRateEditable}
                                                                                        onChange={(e) => updateRangeFeeMasterRate(detail.UserType, detail.Type, detail.IsWeekend, 'Bucket50', e.target.value)} 
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control input-sm"
                                                                                        value={detail?.Bucket100 || 0}
                                                                                        disabled={!isRateEditable}
                                                                                        onChange={(e) => updateRangeFeeMasterRate(detail.UserType, detail.Type, detail.IsWeekend, 'Bucket100', e.target.value)} 
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control input-sm"
                                                                                        value={detail?.Bucket150 || 0}
                                                                                        disabled={!isRateEditable}
                                                                                        onChange={(e) => updateRangeFeeMasterRate(detail.UserType, detail.Type, detail.IsWeekend, 'Bucket150', e.target.value)} 
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control input-sm"
                                                                                        value={detail?.Bucket200 || 0}
                                                                                        disabled={!isRateEditable}
                                                                                        onChange={(e) => updateRangeFeeMasterRate(detail.UserType, detail.Type, detail.IsWeekend, 'Bucket200', e.target.value)} 
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control input-sm"
                                                                                        value={detail?.Club || 0}
                                                                                        disabled={!isRateEditable}
                                                                                        onChange={(e) => updateRangeFeeMasterRate(detail.UserType, detail.Type, detail.IsWeekend, 'Club', e.target.value)} 
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control input-sm"
                                                                                        value={Math.round(detail?.Tax) || 0}
                                                                                        disabled
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control input-sm"
                                                                                        value={Math.round(detail?.Total) || 0}
                                                                                        disabled
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <textarea
                                                                                        className="form-control input-sm"
                                                                                        style={{ width: '100%', height: '40px' }}
                                                                                        rows="3"
                                                                                        value={detail.Remark || ''}
                                                                                        onChange={(e) => updateRangeFeeMasterRate(detail.UserType, detail.Type, detail.IsWeekend, 'Remark', e.target.value)}
                                                                                    ></textarea>
                                                                                </td>
                                                                                {/* <td>{detail?.WeekType}</td> */}
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <div className="clearfix form-actions">
                                                                    <button type="button" id="btnSave" name="btnSave" className="btn btn-primary" onClick={handleSave}>
                                                                        <i className="fa fa-save"></i> Save
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </RightSideDetails>
                            </>}
                        </div>
                    </div>
                </div>
            </div>
            {showModal && (
                <AddRangeFeeCalendar
                    show={showModal}
                    onDismissModal={handleDismissModal}
                    refetchCalendars={refetchCalendars}
                    calendarData={editingCalendar}
                    isEdit={!!editingCalendar}
                />
            )}
        </>
    );
};

export default RangeFeeCalendar;